<template>
  <div
    style="width: 100%; height: 100dvh;"
    class="d-flex flex-column align-center justify-center"
  >
    <div
      class="d-flex"
      style="width: 200px; position: absolute; top: 0; left: 0; margin: 20px;"
    >
      <img
        v-if="isThemeDark"
        src="@/assets/logo-dark.svg"
        width="100%"
        alt="logo"
        height="100%"
      />

      <img
        v-else
        src="@/assets/logo.svg"
        width="100%"
        alt="logo"
        height="100%"
      />
    </div>
    <div
      class="d-flex flex-column align-center justify-center"
      style="width: 500px"
    >
      <img
        src="@/assets/not_found.svg"
        alt="Pedlook"
        class="mb-6"
      />

      <h1 class="mb-4">
        {{  error.statusCode }}
      </h1>
      <p style="text-align: center">
        {{ error.statusMessage }}
      </p>

      <nuxt-link :to="useUseRouteCallbackUrl('/home')">
        Voltar para tela inicial
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const isThemeDark  = false

defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({ statusCode: 500, message: 'Unknown error' })
  }
})
</script>

<style lang="scss" scoped>

</style>
